import React, { useEffect, useRef, useState } from 'react';
import '../CSS/Global.css';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import noresult from "../Images/noresult.webp"
import { INDIA_DATA } from "./indiaStatesCities"

const SearchPage = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]); // Store search results
    const navigate = useNavigate();
    const [storeAll, setStoreAll] = useState([]);
    const searchInputRef = useRef(null);
    const resultRef = useRef(null); // Reference for the results container
    const [nameQuery, setNameQuery] = useState('');
    const [pincodeQuery, setPincodeQuery] = useState('');
    const nameInputRef = useRef(null);
    const pincodeInputRef = useRef(null);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [keyword, setKeyword] = useState("");

    // -------------------------
    // 1. LOAD ALL STATES OF INDIA
    // -------------------------
    useEffect(() => {
        setStates(INDIA_DATA); // load all states
    }, []);



    const handleStateChange = (e) => {
        const stateId = Number(e.target.value);
        setSelectedState(stateId);

        const state = INDIA_DATA.find(s => s.id === stateId);

        setCities(state ? state.cities : []);
        setSelectedCity("");
    };



    const handleSearch = () => {
        console.log("Searching for:", {
            selectedState,
            selectedCity,
            keyword,
        });

        // CALL YOUR SEARCH API HERE
    };

    const handleSearchChange = (event) => {
        setQuery(event.target.value);
    };

    useEffect(() => {
        if (nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, []);

    const fetchDataAll = async () => {
        try {
            const response = await axios.get(`https://filmlocation.100billion.in/store/allstorelist/allstore/adsfk1367tyh`);
            const parsedResults = response.data
                .filter((store) => store.status === "Active") // Check for "Active" status
                .map((store) => ({
                    ...store,
                    additionalEmails: JSON.parse(store.additionalEmails || "[]"),
                    additionalLandlines: JSON.parse(store.additionalLandlines || "[]"),
                    additionalMobiles: JSON.parse(store.additionalMobiles || "[]"),
                    additionalServices: JSON.parse(store.additionalServices || "[]"),
                    additionalWhatsapps: JSON.parse(store.additionalWhatsapps || "[]"),
                    businessDetails: JSON.parse(store.businessDetails || "{}"),
                    businessTiming: JSON.parse(store.businessTiming || "{}"),
                    contactDetails: JSON.parse(store.contactDetails || "{}"),
                    formImages: JSON.parse(store.formImages || "[]"),
                    paymentDetails: JSON.parse(store.paymentDetails || "{}"),
                    servicesDetails: JSON.parse(store.servicesDetails || "{}"),
                }));
            console.log(parsedResults);
            setStoreAll(parsedResults);
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };

    const fetchStores = async () => {
        try {
            const response = await axios.get(`https://filmlocation.100billion.in/store/getstore/search`, {
                params: { name: nameQuery, pincode: pincodeQuery },
            });
            const parsedResults = response.data
                .filter((store) => store.status === "Active")
                .map((store) => ({
                    ...store,
                    additionalEmails: JSON.parse(store.additionalEmails || "[]"),
                    additionalLandlines: JSON.parse(store.additionalLandlines || "[]"),
                    additionalMobiles: JSON.parse(store.additionalMobiles || "[]"),
                    additionalServices: JSON.parse(store.additionalServices || "[]"),
                    additionalWhatsapps: JSON.parse(store.additionalWhatsapps || "[]"),
                    businessDetails: JSON.parse(store.businessDetails || "{}"),
                    businessTiming: JSON.parse(store.businessTiming || "{}"),
                    contactDetails: JSON.parse(store.contactDetails || "{}"),
                    formImages: JSON.parse(store.formImages || "[]"),
                    paymentDetails: JSON.parse(store.paymentDetails || "{}"),
                    servicesDetails: JSON.parse(store.servicesDetails || "{}"),
                }));

            setStoreAll(parsedResults);
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };


    // useEffect(() => {



    //         fetchStores();

    // }, [nameQuery, ]);


    const getFilteredStores = () => {
        return storeAll.filter(store => {

            const businessName = store.businessDetails.businessName?.toLowerCase() || "";
            const service = store.servicesDetails.service?.toLowerCase() || "";
            const category = store.category?.toLowerCase() || "";
            const city = store.businessDetails.city?.toLowerCase() || "";
            const state = store.businessDetails.state?.toLowerCase() || "";
            const pin = store.businessDetails.pincode || "";

            // --- STATE MATCH ---
            const stateMatch = selectedState
                ? state === states.find(s => s.id === selectedState)?.name.toLowerCase()
                : true;

            // --- CITY MATCH ---
            const cityMatch = selectedCity
                ? city === selectedCity.toLowerCase()
                : true;

            // --- KEYWORD MATCH ---
            const keywordMatch = keyword
                ? (
                    businessName.includes(keyword.toLowerCase()) ||
                    category.includes(keyword.toLowerCase()) ||
                    service.includes(keyword.toLowerCase())
                )
                : true;



            // --- NAME MATCH ---
            const nameMatch = nameQuery
                ? businessName.includes(nameQuery.toLowerCase())
                : true;

            // --- PINCODE MATCH ---
            const pincodeMatch = pincodeQuery
                ? pin === pincodeQuery
                : true;

            return stateMatch && cityMatch && keywordMatch && nameMatch && pincodeMatch;
        });
    };


    const handleSearchClick = () => {
        if (nameQuery || pincodeQuery) {
            fetchStores();
        } else {
            fetchDataAll();
        }
    };

    useEffect(() => {


        fetchDataAll();
    }, []);


    // Close results when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (resultRef.current && !resultRef.current.contains(event.target) && !searchInputRef.current.contains(event.target)) {
                setQuery(''); // Clear the query to hide results
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleWhatsAppClick = (storeName, mobile) => {
        const message = `Hi, I would like to inquire about ${storeName}`;
        const phoneNumber = `+91${mobile}`; // Replace with the store's WhatsApp number
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}, '_blank'`);
    };

    const filteredStores = getFilteredStores();


    return (
        <>
            <Header />
            <div className="sub-category-page-header">
                <div
                    className='back-btn-navigate'
                    onClick={() => navigate(-1)}
                    title='Go back'
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </div>
                <div className='sub-category-heading'>Search Services/Listings</div>
                <div></div>
            </div>
            <div className="sub-category-page-search">
                {/* <i className="fa fa-search search-page-icon"></i> */}
                <div className="big-search-bar">

                    {/* STATE DROPDOWN */}
                    <select value={selectedState} onChange={handleStateChange} className="search-select">
                        <option value="">Select State</option>

                        {states.map((state) => (
                            <option key={state.id} value={state.id}>
                                {state.name}
                            </option>
                        ))}
                    </select>



                    {/* CITY DROPDOWN */}
                    <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)} disabled={!selectedState} className="search-select">
                        <option value="">Select City</option>

                        {cities.map((city, index) => (
                            <option key={index} value={city}>
                                {city}
                            </option>
                        ))}
                    </select>



                    {/* KEYWORD INPUT */}
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Category / Keywords"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />

                    {/* SEARCH BUTTON */}
                    <button className="main-search-btn" onClick={handleSearch}>
                        Search
                    </button>
                </div>
            </div>



            <div className="search-cards-page">
                {filteredStores.length > 0 ? (
                    filteredStores.map((item, index) => (
                        <div className="bigbull-card" key={index}>
                            <div className="card-body">
                                <div
                                    className="card-body-img"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    <img
                                        src={`https://filmlocation.100billion.in/${item.formImages[0]}`}
                                        alt=""
                                    />
                                </div>
                                <p
                                    className="store-name"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    {item.businessDetails.businessName}
                                </p>
                                <p
                                    className="store-address"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    {[
                                        item.businessDetails.buildingName,
                                        item.businessDetails.street,
                                        item.businessDetails.area,
                                        item.businessDetails.landmark,
                                        item.businessDetails.city,
                                        item.businessDetails.state,
                                        item.businessDetails.pincode
                                    ]
                                        .filter(Boolean) // Filters out empty, null, or undefined values
                                        .join(', ')}
                                </p>
                                <p
                                    className="rating"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    <span className='rating-average'>5.0</span> <i className="fa-solid fa-star"></i>{' '}
                                    <span className='no-of-ratings'>12 Ratings</span>
                                </p>
                                <div className="card-body-btn">
                                    <Link to={`tel:${item.contactDetails.mobile}`}>
                                        <button className="contact"><i className="fa-solid fa-phone"></i> Contact us</button>
                                    </Link>
                                    <button className="whatsapp" onClick={() => handleWhatsAppClick(item.businessDetails.businessName, item.contactDetails.whatsapp)}>
                                        <i className="fa-brands fa-whatsapp"></i> Whatsapp
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-results">
                        <img src={noresult} alt="No results found" className="no-results-image" />
                        <p className="no-results-text">No store found</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default SearchPage;




































































// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import '../CSS/Global.css';
// import { useNavigate } from 'react-router-dom';

// const SearchPage = () => {
//     const [query, setQuery] = useState('');
//     const [results, setResults] = useState([]); // Store search results
//     const navigate = useNavigate()

//     const handleSearchChange = (event) => {
//         setQuery(event.target.value);
//     };

//     useEffect(() => {
//         // Fetch stores whenever the query changes
//         const fetchStores = async () => {
//             try {
//                 const response = await axios.get(https://filmlocation.100billion.in/store/getstore/search, {
//                     params: { name: query },
//                 });

//                 // console.log(response);
//                 const parsedResults = response.data.map((store) => {
//                     return {
//                         ...store,
//                         additionalEmails: JSON.parse(store.additionalEmails || "[]"),
//                         additionalLandlines: JSON.parse(store.additionalLandlines || "[]"),
//                         additionalMobiles: JSON.parse(store.additionalMobiles || "[]"),
//                         additionalServices: JSON.parse(store.additionalServices || "[]"),
//                         additionalWhatsapps: JSON.parse(store.additionalWhatsapps || "[]"),
//                         businessDetails: JSON.parse(store.businessDetails || "{}"),
//                         businessTiming: JSON.parse(store.businessTiming || "{}"),
//                         contactDetails: JSON.parse(store.contactDetails || "{}"),
//                         formImages: JSON.parse(store.formImages || "[]"),
//                         paymentDetails: JSON.parse(store.paymentDetails || "{}"),
//                         servicesDetails: JSON.parse(store.servicesDetails || "{}"),
//                     };
//                 });
//                 console.log(parsedResults);
//                 setResults(parsedResults);
//             } catch (error) {
//                 console.error("Error fetching stores:", error);
//             }
//         };
//         if (query) {
//             fetchStores();
//         } else {
//             setResults([]); // Clear results if query is empty
//         }
//     }, [query]);

//     return (
//         <div className="search-page">
//             <input
//                 type="text"
//                 placeholder="Search for store..."
//                 className="search-page__input"
//                 value={query}
//                 onChange={handleSearchChange}
//             />

//         </div>
//     );
// };

// export default SearchPage;